export default __webpack_public_path__ + "static/media/landing-phone-original.edba882d.png";